var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4293 15.5725H7.99846C7.44623 15.5725 6.99805 15.1243 6.99805 14.572V9.42791C6.99805 8.87568 7.44623 8.42749 7.99846 8.42749H12.4293C12.9815 8.42749 13.4297 8.87568 13.4297 9.42791V14.5731C13.4297 15.1253 12.9815 15.5725 12.4293 15.5725Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4297 11.2857L15.4265 9.28888C15.5206 9.19484 15.6476 9.14282 15.7807 9.14282H16.502C16.7781 9.14282 17.0022 9.36692 17.0022 9.64303V14.359C17.0022 14.6351 16.7781 14.8592 16.502 14.8592H15.7807C15.6476 14.8592 15.5206 14.8062 15.4265 14.7131L13.4297 12.7163",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0019 21.0038H6.99776C4.78784 21.0038 2.99609 19.2121 2.99609 17.0022V6.998C2.99609 4.78808 4.78784 2.99634 6.99776 2.99634H17.0019C19.2118 2.99634 21.0036 4.78808 21.0036 6.998V17.0022C21.0036 19.2121 19.2118 21.0038 17.0019 21.0038Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraSquare);
export default __webpack_public_path__ + "static/media/camera-square.dc82a5a510c6d1a0f7d470a335666644.svg";
export { ForwardRef as ReactComponent };